import { Box, Heading } from "@ogt/ui";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

export default function SubscriptionStarted() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();

  return (
    <Box fullwidth>
      <Heading className="h2" headingRef={h2Ref} id="thankYouHeading" focusable>
        Välkommen ombord
      </Heading>
      <div role="group">
        <p>
          Vad roligt att du vill vara med på den här resan. Du är nu registrerad
          och får våra nyhetsbrev. Då får du bland annat läsa det här:
        </p>
        <ul>
          <li>Nyheter</li>
          <li>Ändringar i trafiken</li>
          <li>Smarta funktioner i appen</li>
          <li>Tips som gör resan enklare</li>
          <li>Och alltid en påminnelse när det är ny tidtabell</li>
        </ul>
        <p>
          Kort och gott. Vi håller dig i rullning så du inte missar något
          viktigt.{" "}
        </p>

        <p>
          Psst! Skulle du ändra dig och inte vill vara med på tåget längre, kan
          du när som helst avregistrera dig via länken längst ner i varje mejl
        </p>

        <p>Trevlig resa!</p>
      </div>
    </Box>
  );
}
